import { useMemo } from 'react';
import { SelectInputOption } from '@/components/inputs/SelectInput';
import { UserApi, UserStatus } from '../../Users/models';
import { useUsers } from '../../Users/hooks';

interface UseUsersOptionsFilters {
  search?: string;
  email?: string;
  phone?: string;
  status?: string;
}

const useUsersOptions = (filters: UseUsersOptionsFilters = {}) => {
  const { search = '', email = '', phone = '', status } = filters;

  const statusFilter = status ? (status as UserStatus) : UserStatus.ENABLED;

  const { users, isUsersLoading } = useUsers({
    filters: {
      fullName: search,
      email,
      phone,
      status: statusFilter,
    },
    paginated: {
      page: 1,
      pageSize: 5,
    },
  });

  const usersOptions = useMemo<SelectInputOption[]>(
    () =>
      (users ?? []).map((user: UserApi) => ({
        value: user.id,
        label: user.fullName,
        email: user.email,
      })),
    [users]
  );

  return { usersOptions, users: users ?? [], isUsersLoading };
};

export default useUsersOptions;
